// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._35QdB:focus {\r\n    border-color: #CED4DA;\r\n    box-shadow: 0 0 0 0.25rem rgba(206, 212, 218, 0.25);\r\n}", ""]);
// Exports
module.exports = exports;
